import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconColumnWide: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconColumnWide"><Path d="M2.5 19.5H2V20H2.5V19.5ZM2.5 4.5V4H2V4.5H2.5ZM21.5 4.5H22V4H21.5V4.5ZM21.5 19.5V20H22V19.5H21.5ZM3 19.5V4.5H2V19.5H3ZM21 4.5V19.5H22V4.5H21ZM21.5 19H2.5V20H21.5V19ZM2.5 5H21.5V4H2.5V5Z" fill="currentColor"/><Path d="M11.5 19.5V20H12.5V19.5H11.5ZM12.5 4.5V4H11.5V4.5H12.5ZM12.5 19.5V4.5H11.5V19.5H12.5Z" fill="currentColor"/></CentralIconBase>;
});

export default IconColumnWide;
